import {get, post} from "@/config/api";

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  CheckIn({}, params) {
    return new Promise((resolve, reject) => {
      get('v2/activity/checkin/', params).then((data) => {
        resolve(data)
      }, (err)=> {
        reject(err)
      })
    })
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
